export const FinanceKeys = {
	all: ["finance"] as const,
	expenseDictionary: () => [...FinanceKeys.all, "expenseDictionary"] as const,
	income: () => [...FinanceKeys.all, "income"] as const,
	expense: () => [...FinanceKeys.all, "expense"] as const,
	types: () => [...FinanceKeys.all, "types"] as const,
	reporting: () => [...FinanceKeys.all, "reporting"] as const,
};
